import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=6228142d&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228142d",
  null
  
)

export default component.exports